<template>
  <!-- TKP-187 / md.85: KVKK modülüyle aynı kabuk (layouts/kvkk/vertical.vue) — açık üst çubuk, logolu sol dikey menü, alt bilgi -->
  <div class="gdpr-page tasks-page">
    <header-comp />
    <side-bar type="light" width="fluid" />
    <main>
      <div class="container-fluid">
        <!-- `task-detail` modalını görev ekranlarının kendisi basıyor; burada ikinci kez basılmaz. -->
        <slot />
      </div>
    </main>
    <footer-comp />
  </div>
</template>

<script>
/**
 * TKP-118 / tasarım s.24 md.1 — Görevler modülünün layout'u. TKP-187 (md.85): organizasyon panelinin ikon menüsü yerine
 * KVKK/GDPR/RİSK ürün modüllerinin yerleşimi; menü kalemleri ve yetki kuralları side-bar.vue'da aynı kaldı.
 */
import FooterComp from "../footer";
import HeaderComp from "./header";
import SideBar from "./side-bar";

export default {
  components: { HeaderComp, SideBar, FooterComp },
  created: () => {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
  },
  mounted() {
    document.body.classList.remove("vertical-collpsed");
  },
};
</script>
